function parseMonthKey(monthKey: string): Date | null {
  const match = /^(\d{4})-(\d{2})$/.exec(monthKey.trim());
  if (!match) return null;
  const year = Number(match[1]);
  const month = Number(match[2]);
  if (!Number.isInteger(year) || !Number.isInteger(month) || month < 1 || month > 12) return null;
  return new Date(Date.UTC(year, month - 1, 1));
}

export function getCompanyInsightCoverageStart(
  monthlyCounts?: Record<string, number> | null,
): Date | null {
  if (!monthlyCounts) return null;
  const dates = Object.keys(monthlyCounts)
    .map(parseMonthKey)
    .filter((d): d is Date => d instanceof Date && !Number.isNaN(d.getTime()));
  if (dates.length === 0) return null;
  return dates.reduce((min, current) => (current.getTime() < min.getTime() ? current : min));
}

export function formatCoverageStartDate(
  coverageStart: Date | null,
  locale: string,
): string | null {
  if (!coverageStart) return null;
  try {
    return new Intl.DateTimeFormat(locale, { month: 'long', year: 'numeric' }).format(coverageStart);
  } catch {
    return new Intl.DateTimeFormat('en', { month: 'long', year: 'numeric' }).format(coverageStart);
  }
}

